<script setup lang="ts">
import { computed } from 'vue'
interface PropTypes {
  statuses: Array<'loading' | 'error' | 'success'>
  showStale?: boolean
}

const props = defineProps<PropTypes>()

const status = computed<'loading' | 'error' | 'success'>(() => {
  if (props.statuses.length === 1) {
    return props.statuses[0]
  }
  const loadingCount = props.statuses.filter((s) => s === 'loading').length
  const errorCount = props.statuses.filter((s) => s === 'error').length
  const successCount = props.statuses.filter((s) => s === 'success').length
  let serverStatus
  switch (true) {
    case errorCount > 0:
      serverStatus = 'error'
      break
    case loadingCount > 0:
      serverStatus = 'loading'
      break
    case successCount === props.statuses.length:
      serverStatus = 'success'
      break
    default:
      serverStatus = 'error'
  }
  return serverStatus
})
</script>

<template>
  <template v-if="status === 'loading'">
    <slot name="loading" />
  </template>
  <template v-if="status === 'error'">
    <slot name="error" />
  </template>
  <template v-if="status === 'success'">
    <slot name="success" />
  </template>
</template>
